export const DefaultDateFormat = 'DD/MM/YYYY';
export const DefaultDateTimeFormat = 'DD/MM/YYYY, HH:mm';
export const LastViewedDateTimeFormat = 'HH:mm - DD/MM/YYYY';
export const ShortDateFormat = 'D/M/YYYY';
export const LongDateFormat = `ddd, ${DefaultDateFormat}`;
export const EmptyDateTimePlaceholder = '--/--/---- --:--';
export const FullDateTimeFormat = 'DD/MM/YYYY HH:mm:ss';
export const ShortDateTimeFormat = 'DD/MM/YYYY HH:mm';
export const DayOfMonthFormat = 'DD';
export const ISO8601DateFormat = 'YYYY-MM-DD';
export const FullDateTimeFormatWithDayOfWeek = `dddd, ${DefaultDateTimeFormat}`;
export const UserViewedDateTimeFormat = 'dddd, D [tháng] M, YYYY [lúc] HH:mm';
export const TimeFormatList = [
  'HH:mm',
  'h:mm A',
  'HH:mm:ss',
  'h:mm:ss A',
  'HH[h]mm',
];
